import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { userAtom } from '@/recoil/atoms/user.atom';

interface LoginRedirectProps {
  children: React.ReactNode;
}

const LoginRedirect: React.FC<LoginRedirectProps> = ({ children }) => {
  const user = useRecoilValue(userAtom);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // 이미 인증된 사용자의 역할에 따라 리디렉션
    if (user && user.isAuth) {
      if (location.pathname === '/') {
        if (user.role_name === 'admin' || user.role_name === 'super') {
          navigate('/admin/dashboard', { replace: true });
        } else if (user.role_name === 'advertiser') {
          navigate('/admin/campaign', { replace: true });
        }
      }
    }
  }, [user, navigate, location.pathname]);

  return <>{children}</>;
};

export default LoginRedirect;
